import '../analytics/events.js';
import '../node_modules/tslib/tslib.es6.js';
import 'uuid';
import 'lodash/includes';
import '../types/filters.js';
export { BC_MEDIA_DOMAIN, BC_TESTIMONIALS, BC_VIDEOS, getAssetNameFromUrl, getBrandLogo, getDefaultBrandclubImage, getDefaultProductImage, getEntityImage, getFallbackBrandclubImage, getFallbackProductImage, getFeaturedRetailerImage, getImageAssetUrl } from './assetUtils.js';
export { default as BrandclubStoreConfigUtils } from './brandclubStoreConfigUtils.js';
import 'numeral';
export { BRANDCLUB_SHOPIFY_RETAILERS, changeAmazonImageUrlResolution, decodeHTMLCharacters, escapeUriPath, formatMoney, getContrastColor, getNumericValue, getRetailerFromId, getRootFontSize, isParentProduct, isShopifyProduct, isWhite, parseThemeUrl, pxToRem, remToPx, removeTrailingSlash, roundFloat } from './stringUtils.js';
export { BrandclubCheckoutBroadcast, BroadCastMessage } from './broadcast.js';
export { BRANDCLUB_BRAND_ID, BRANDCLUB_RETAILERS, DEFAULT_LINK_ID, DESKTOP_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DIALOG_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, PLACEHOLDER_GREEN_IMAGE, SMALL_MOBILE_SCREEN_SIZE, SMALL_TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, TABLET_SCREEN_SIZE, UNIVERSAL_STORE_SITE, WIDGET_MEDIA_BORDER_RADIUS, WIDGET_PAIR_PRODUCT_PADDING, WIDGET_SPACE, WIDGET_SPACE_HALF, XL_DESKTOP_SCREEN_SIZE } from './constants/Constants.js';
import 'awesome-phonenumber';
import 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '../types/Campaign.js';
import '../types/product.js';
import '../api/graphQl/brand.js';
import '../api/graphQl/product.js';
import '../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
export { Logger } from './logger.js';

const isCrossDomainUrl = (targetUrl) => {
    try {
        const target = typeof targetUrl === 'string' ? new URL(targetUrl) : targetUrl;
        const current = new URL(window.location.href);
        return target.hostname !== current.hostname;
    }
    catch (e) {
        console.error('Invalid URL for cross-domain check:', e);
        return false;
    }
};

export { isCrossDomainUrl };
//# sourceMappingURL=index.js.map
